module.exports = __webpack_public_path__ + "img/logo-wms.a197b0ed.svg";